var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0707 2.92929C15.181 1.03956 12.6726 0 10 0C7.32744 0 4.81902 1.03956 2.92929 2.92929C1.03956 4.81902 0 7.32744 0 10C0 12.6726 1.03956 15.181 2.92929 17.0707C4.81902 18.9604 7.32744 20 10 20C12.6726 20 15.181 18.9604 17.0707 17.0707C18.9604 15.181 20 12.6726 20 10C20 7.32744 18.9604 4.81902 17.0707 2.92929ZM16.2668 16.2668C14.5918 17.9419 12.3653 18.8636 10 18.8636C7.63468 18.8636 5.40825 17.9419 3.73316 16.2668C0.277778 12.8114 0.277778 7.18855 3.73316 3.73316C5.40825 2.05808 7.63468 1.13636 10 1.13636C12.3653 1.13636 14.5918 2.05808 16.2668 3.73316C19.7222 7.18855 19.7222 12.8114 16.2668 16.2668Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 5.59357C14.1831 5.3705 13.8254 5.3705 13.6023 5.59357L9.99964 9.19626L6.39695 5.59357C6.17389 5.3705 5.81614 5.3705 5.59308 5.59357C5.37002 5.81663 5.37002 6.17438 5.59308 6.39744L9.19577 10.0001L5.59308 13.6028C5.37002 13.8259 5.37002 14.1836 5.59308 14.4067C5.70251 14.5161 5.84981 14.5751 5.99291 14.5751C6.13601 14.5751 6.28331 14.5203 6.39274 14.4067L9.99543 10.804L13.5981 14.4067C13.7075 14.5161 13.8549 14.5751 13.998 14.5751C14.1453 14.5751 14.2884 14.5203 14.3978 14.4067C14.6208 14.1836 14.6208 13.8259 14.3978 13.6028L10.8035 10.0001L14.4062 6.39744C14.6293 6.17438 14.6293 5.81663 14.4062 5.59357Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveProduct);
export default __webpack_public_path__ + "static/media/removeProduct.004db09969c9015bcdb4596fa89ec7e3.svg";
export { ForwardRef as ReactComponent };